export default class ChecklistTeams {
    name = '';
}